<template>
  <div>
    <v-dialog ref="dialog" persitent v-model="dialog" max-width="600">
      <v-card>
        <v-card-title>{{ title }} {{ selectedItem.name }}</v-card-title>
        <v-card-text>
          <span style="font-size: 0.8rem"
            >De acordo com preferência do aluno escolha
            <strong>{{ selectedItem.frequency }}</strong>
            {{ selectedItem.frequency === 1 ? "opção" : "opções" }} de
            horários</span
          >
          <v-row dense>
            <v-col
              class="d-flex align-center justify-start"
              cols="12"
              v-for="(day, index) in displayDates"
              :key="index"
              style="height: auto; width: auto"
            >
              <v-checkbox
                v-model="selected"
                :label="`${displayDay(day.weekDay)} de ${day.start} até ${
                  day.end
                } `"
                :value="day"
                :disabled="
                  selected.length === selectedItem.frequency &&
                  !selected.includes(day)
                "
              >
              </v-checkbox>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1" text @click="close"> Cancelar </v-btn>
          <v-btn
            color="green darken-1"
            text
            @click="confirm"
            :disabled="selected.length !== selectedItem.frequency"
          >
            Confirmar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: "confirmation-dialog",
  props: {
    title: {
      type: String,
    },
    text: {
      type: String,
    },
    items: {
      type: [Array, null],
    },
    displayDates: {
      type: [Array, null],
    },
    selectedItem: {
      type: Object,
    },
  },
  data() {
    return {
      dialog: false,
      selected: [],
      days: [
        {
          text: "Domingo",
          value: 0,
        },
        {
          text: "Segunda-feira",
          value: 1,
        },
        {
          text: "Terça-feira",
          value: 2,
        },
        {
          text: "Quarta-feira",
          value: 3,
        },
        {
          text: "Quinta-feira",
          value: 4,
        },
        {
          text: "Sexta-feira",
          value: 5,
        },
        {
          text: "Sábado",
          value: 6,
        },
      ],
    };
  },
  methods: {
    open() {
      this.dialog = true;
    },
    close() {
      this.dialog = false;
      this.$emit("cancel");
    },
    confirm() {
      this.$emit("confirmed", this.selected);
      this.dialog = false;
    },
    displayDay(day) {
      return this.days.find((d) => d.value === day).text;
    },
  },
};
</script>

<style lang="css" scoped></style>
